import React, { useState } from 'react';
import { FaRegCalendarAlt, FaTimes } from 'react-icons/fa';
import { HiOutlineTicket } from 'react-icons/hi2';
import { IoCalendarOutline } from 'react-icons/io5';
import { BsLightbulbFill } from 'react-icons/bs';
import { MdSearch, MdShoppingCart } from 'react-icons/md';
import styles from './style.module.scss';

const ModalVerBoloes = ({
  nome,
  modalSetConcursoAndState,
  
  regra,
  concurso,
  dataSorteio,
  valor,
  isModalVisible,
  closeModal,
  color,
  cotas,
  handleAddToCart,
  subBolaoCart,
  setModalVerApostas,
  quantidadeApostas,
}) => {
  console.log('valor', valor)
  const formatDate = (dateString) => {
    const options = { month: '2-digit', day: '2-digit' };
    return new Date(dateString).toLocaleDateString('pt-BR', options);
  };

  const hexToRGBA = (hex, opacity) => {
    if (!hex) return '';
    hex = hex.replace('#', '');
    if (hex.length === 3) {
      hex = hex
        .split('')
        .map((hexChar) => hexChar + hexChar)
        .join('');
    }
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity})`;
  };

  const formatarRegra = (regra) => {
    if (!regra) return ['', ''];
    const regraFormatada = regra
      .replace(/\[\[([^\]]+)\]\]/g, '<h2>$1</h2>')
      .replace(/\*\*\*/g, '<p>')
      .replace(/\*\*/g, '</p>')
      .replace(/\{\{/g, '<strong>')
      .replace(/\}\}/g, '</strong>')
      .replace(/\/\/\s*/g, '<br/>')
      .replace(/\|\|\s*/g, '<hr/>')
      .replace('<h2>DESCRIÇÃO DA ESTRATÉGIA</h2>', '');

    const returnRegra = regraFormatada.split(/<h2>MATRIZ/);
    const primeiroTexto = returnRegra[0];
    let segundoTexto = '';
    for (let i = 1; i < returnRegra.length; i++) {
      segundoTexto += returnRegra[i];
    }
    return [primeiroTexto, segundoTexto];
  };

  const handleVerJogos = () => {
    closeModal();
    modalSetConcursoAndState(subBolaoCart);
  };

  const regrasFormatadas = formatarRegra(regra);

  if (!isModalVisible) return null;

  return (
    <div className={styles.modalOverlay} onClick={closeModal}>
      <div className={styles.modal} onClick={(e) => e.stopPropagation()}>
        {/* Modal Header */}
        <div className={styles.modalHeader} style={{ backgroundColor: color }}>
          <h1 className={styles.modalTitle}>{nome}</h1>
          <button className={styles.closeButton} onClick={closeModal}>
            <FaTimes />
          </button>
        </div>

        {/* Modal Content */}
        <div className={styles.modalContent}>
          {/* Prize and Info Section */}
          <div
            className={styles.infoSection}
            style={{
              borderColor: color,
              backgroundColor: hexToRGBA(color, 0.1),
            }}
          >
            <div className={styles.prizeDisplay}>
              <h2 className={styles.prizeValue} style={{ color: color }}>
                {valor}
              </h2>
            </div>

            <div className={styles.divider} style={{ backgroundColor: color }}></div>

            <div className={styles.infoGrid}>
              <div className={styles.infoItem}>
                <IoCalendarOutline className={styles.infoIcon} style={{ backgroundColor: color, padding: 5 }} />
                <div className={styles.infoText}>
                  <span className={styles.infoLabel}>Sorteio</span>
                  <span className={styles.infoValue} style={{ color: color }}>
                    {formatDate(dataSorteio)}
                  </span>
                </div>
              </div>

              <div className={styles.infoItem}>
                <HiOutlineTicket className={styles.infoIcon} style={{ backgroundColor: color, padding: 5 }} />
                <div className={styles.infoText}>
                  <span className={styles.infoLabel}>Concurso</span>
                  <span className={styles.infoValue} style={{ color: color }}>
                    {concurso}
                  </span>
                </div>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className={styles.actionSection}>
            <h3 className={styles.actionTitle}>Quando você compara, aposta com a Tribo</h3>

            <div className={styles.buttonGrid}>
              <button className={styles.actionButton} onClick={handleVerJogos} style={{ backgroundColor: color }}>
                <MdSearch />
                Ver jogos
              </button>

              <button
                className={styles.actionButton}
                onClick={() => {
                  handleAddToCart(nome, subBolaoCart, 1);
                  // GTM Event
                  window.dataLayer = window.dataLayer || [];
                  window.dataLayer.push({
                    event: 'purchase',
                    product: {
                      name: nome,
                      subBolao: subBolaoCart,
                      quantidade: 1,
                      valor: valor,
                    },
                  });
                }}
                style={{ backgroundColor: '#feac24' }}
              >
                <MdShoppingCart />
                Add carrinho
              </button>
            </div>
          </div>

          {/* Strategy Section */}
          <div
            className={styles.strategySection}
            style={{
              borderColor: color,
              backgroundColor: hexToRGBA(color, 0.1),
            }}
          >
            <h3 className={styles.sectionTitle}>
              <BsLightbulbFill style={{ color: color }} />
              Nossa Estratégia
            </h3>
            <div dangerouslySetInnerHTML={{ __html: regrasFormatadas[0] }} className={styles.strategyContent} />
          </div>

          {/* Matrix Section */}
          {regrasFormatadas[1] !== '' && (
            <div
              className={styles.matrixSection}
              style={{
                borderColor: color,
                backgroundColor: hexToRGBA(color, 0.1),
              }}
            >
              <h3 className={styles.sectionTitle}>
                <BsLightbulbFill style={{ color: color }} />
                Nossas Matrizes
              </h3>
              <div dangerouslySetInnerHTML={{ __html: regrasFormatadas[1] }} className={styles.matrixContent} />
            </div>
          )}

          {/* Payment Section */}
          <div
            className={styles.paymentSection}
            style={{
              borderColor: color,
              backgroundColor: hexToRGBA(color, 0.1),
            }}
          >
            <h3 className={styles.sectionTitle}>
              <BsLightbulbFill style={{ color: color }} />
              Pagamento
            </h3>
            <div className={styles.paymentContent}>
              <h4>Os Pagamentos das premiações serão lançados no SALDO de sua Conta, logo no primeiro dia útil após o sorteio.</h4>
              <p>Nossos bolões possuem alta chance de premiação e estão relacionados com estatísticas de cada loteria.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ModalVerBoloes;
